/**
 * SupplyBar — Days-of-supply bar (same 10-segment pattern)
 * GREEN >7 days, AMBER 3-7 days, RED <3 days
 */

function getSupplyColor(days: number): string {
  if (days > 7) return '#22c55e'
  if (days > 3) return '#f59e0b'
  return '#ef4444'
}

interface SupplyBarProps {
  daysOfSupply: number
  status?: string
  compact?: boolean
  maxDays?: number  // for scaling the bar (default 14)
}

export function SupplyBar({ daysOfSupply, status, compact = false, maxDays = 14 }: SupplyBarProps) {
  const color = getSupplyColor(daysOfSupply)
  const filled = Math.min(10, Math.round((daysOfSupply / maxDays) * 10))
  const label = daysOfSupply >= 100 ? '99+d' : `${daysOfSupply.toFixed(1)}d`

  if (compact) {
    return (
      <div className="flex items-center gap-1.5">
        <div className="flex gap-[1px]">
          {Array.from({ length: 10 }, (_, i) => (
            <div
              key={i}
              className="w-[5px] h-3 rounded-[1px]"
              style={{ backgroundColor: i < filled ? color : '#3a3a5c40' }}
            />
          ))}
        </div>
        <span className="text-[10px] tabular-nums w-8 text-right" style={{ color }}>
          {label}
        </span>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <span className="text-xs font-bold tabular-nums" style={{ color }}>
          {label}
        </span>
        {status && (
          <span
            className="text-[10px] font-bold px-1.5 py-0.5 rounded"
            style={{ backgroundColor: `${color}20`, color, border: `1px solid ${color}40` }}
          >
            {status}
          </span>
        )}
      </div>
      <div className="flex gap-[2px] h-3">
        {Array.from({ length: 10 }, (_, i) => (
          <div
            key={i}
            className="flex-1 rounded-sm"
            style={{ backgroundColor: i < filled ? color : '#3a3a5c40' }}
          />
        ))}
      </div>
    </div>
  )
}
